import * as React from 'react';

import { useBoolean, useRequest } from 'ahooks';
import { Drawer, Layout, Spin } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';

import { PrimitiveResult } from 'components';
import { useMediaQuery } from 'hooks';
import { decodeIdentityToken } from 'lib';
import { RefreshTokenProvider } from 'providers';

import { PrivateHeader, PrivateSidebar } from './components';

const PrivateLayout = () => {
  const [open, { toggle: toggleOpen, setFalse: setFalseOpen }] = useBoolean();
  const [collapsed, { toggle: toggleCollapsed }] = useBoolean();
  const { pathname, search } = useLocation();
  const {
    data: decodedIdentityTokenData,
    loading: decodedIdentityTokenLoading,
  } = useRequest(decodeIdentityToken);
  const { lg: matchesLg } = useMediaQuery();

  React.useEffect(() => {
    setFalseOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);

  const { decodedAccessToken } = decodedIdentityTokenData ?? {};
  const { nameid: userId, scope: userScopes = [] } = decodedAccessToken ?? {};

  const isAccessAllowed = userScopes.length > 0;
  const shouldAllowAccess = decodedIdentityTokenLoading || isAccessAllowed;

  return (
    <RefreshTokenProvider>
      <Layout>
        {matchesLg ? (
          <Layout.Sider
            collapsible
            width='15%'
            trigger={null}
            collapsed={collapsed}
          >
            <PrivateSidebar collapsed={collapsed} />
          </Layout.Sider>
        ) : (
          <Drawer
            height='80%'
            placement='bottom'
            closable={false}
            open={open}
            onClose={() => setFalseOpen()}
          >
            <PrivateSidebar showLogo={false} />
          </Drawer>
        )}

        <Layout className='min-h-dvh'>
          <Layout.Header className='bg-[unset] pe-6 ps-4'>
            <PrivateHeader
              userId={userId}
              toggleSidebar={matchesLg ? toggleCollapsed : toggleOpen}
            />
          </Layout.Header>
          <Layout.Content className='bg-[--ant-color-primary-bg] p-6'>
            <Spin
              tip='در حال راستی‌آزمایی اطلاعات...'
              wrapperClassName='h-full [&_.ant-spin-container]:h-full [&_.ant-spin-text]:pt-4 [&_.ant-spin.ant-spin-spinning]:max-h-full'
              spinning={decodedIdentityTokenLoading}
            >
              {!shouldAllowAccess ? (
                <PrimitiveResult
                  status='error'
                  title='عدم دسترسی به پنل'
                  subTitle='شما مجوز لازم برای دسترسی به این پنل را ندارید.'
                />
              ) : (
                <Outlet />
              )}
            </Spin>
          </Layout.Content>
        </Layout>
      </Layout>
    </RefreshTokenProvider>
  );
};

export { PrivateLayout };
